import { createSlice } from "@reduxjs/toolkit";
import {      reKyc_UpdateOtherDetailsThunk } from "./thunk";

export const initialState = {
  reKyc_UpdateOthersDetailData: [],
  reKyc_UpdateOthersDetailError: '', // for error message
  reKyc_UpdateOthersDetailLoading: false,
  
  
};

const Re_Kyc_Update_Others_Details = createSlice({
  name: "Re_Kyc_Update_Others_Details",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_UpdateOtherDetailsThunk.pending, (state) => {
      state.reKyc_UpdateOthersDetailLoading = true ;
      state.reKyc_UpdateOthersDetailData= [];
      state.reKyc_UpdateOthersDetailError='';

  });
    builder.addCase(reKyc_UpdateOtherDetailsThunk.fulfilled, (state, action) => {
        state.reKyc_UpdateOthersDetailData = action.payload.data;
        state.reKyc_UpdateOthersDetailLoading = false ;
    });
    builder.addCase(reKyc_UpdateOtherDetailsThunk.rejected, (state, action) => {
      state.reKyc_UpdateOthersDetailError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_UpdateOthersDetailLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Update_Others_Details.actions

export default Re_Kyc_Update_Others_Details.reducer;